import React, { useEffect, useState } from "react";
import { wsRequest } from "./wsClient.js";
import Footer from "./Footer.jsx";

// Renders a root-authored content page (About, FAQ, or anything else
// added via the admin panel's Content tab) within the app's own
// layout — same look and feel the site's own /about and /faq pages
// always had (SiteHeader above, this centered content area, Footer
// below), same tab, not a bare standalone page. Unlike legal
// documents (still served directly by the backend at /legal/:key, a
// deliberately separate, bare page so a shared link works outside the
// site too), a content page is meant to feel like a genuine part of
// this site.
export default function ContentPage({ slug }) {
  const [page, setPage] = useState(undefined); // undefined = loading, null = not found

  useEffect(() => {
    setPage(undefined);
    wsRequest("content.list")
      .then((list) => setPage(list.find((p) => p.slug === slug) || null))
      .catch(() => setPage(null));
  }, [slug]);

  return (
    <div style={{ color: "var(--text-primary)", minHeight: "100vh" }}>
      <div style={{ maxWidth: 700, margin: "0 auto", padding: "0 20px 40px" }}>
        {page === undefined && <p style={{ opacity: 0.7 }}>Loading…</p>}
        {page === null && (
          <>
            <h2>Page not found</h2>
            <p style={{ opacity: 0.85 }}>This page doesn't exist, or may have been removed.</p>
          </>
        )}
        {page && (
          <>
            <h2>{page.title}</h2>
            <div style={{ opacity: 0.85, lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: page.html || "" }} />
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
